import { FC, ReactNode } from "react";
import { Box } from "@mui/material";

type Props = {
  children?: ReactNode;
  index: number;
  value: number;
};

const TabPanel: FC<Props> = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`}>
    {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
  </div>
);

export default TabPanel;
